// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1FR0e","productName":"Table_productName__39nGy"};